<template>
    <div>
        <help-bubble :shown="!shown && hasSteps" @click="forceStart"/>
        <div v-show="showEnablePopup" class="absolute flex items-center justify-center h-full w-full">
            <div class="absolute" id="onboarding-noscroll-2"><div class="absolute" id="onboarding-highlight"></div></div>

            <div class="relative flex flex-col bg-white w-1/3 h-1/3 justify-evenly rounded-xl items-center" style="z-index: 49;">
                <div @click="close()" class="absolute top-0 self-end mt-2 transform scale-50">
                    <close-button/>
                </div>
                <div class="flex flex-col mt-2 justify-center items-center">
                    <h1 class="text-xl font-medium mb-1">Bienvenue sur Neopass</h1>
                    <p v-if='false' class="text-base-0 text-gray-600 w-3/4 text-center">Pour faciliter l’utilisation de votre carnet de parcours et de compétences, nous vous proposons d’activer le bouton “je valide” ci-dessous. Vous serez ainsi guidé étape par étape dans la création de votre carnet.</p>
                    <p v-else class="text-base-0 text-gray-600 w-3/4 text-center">
                      Cliquer sur “je valide” pour être guidé(e).
                    </p>
                </div>

                <div class="flex flex-row w-full justify-center gap-4 h-8 mb-2">
                    <action-button
                            libelle="Activer plus tard"
                            class="text-2sm"
                            borderColor="border-indigo-400"
                            textColor="text-indigo-600"
                            bgColor="bg-indigo-300"
                            bgColorSquare="bg-indigo-300"
                            iconColor="text-indigo-600"
                            :uppercase="false"
                            :right="false"
                            :responsive="false"
                            @clickAction="showEnablePopup = false"
                    />
                    <action-button
                            libelle="Je valide"
                            class="text-2sm"
                            borderColor="border-transparent"
                            textColor="text-white"
                            bgColor="bg-indigo-600"
                            bgColorSquare="bg-transparent"
                            iconColor="text-white"
                            :uppercase="false"
                            :right="true"
                            :responsive="false"
                            @clickAction="enable"
                    />
                </div>
            </div>
        </div>
        <div v-show="shown"  class="absolute h-full w-full">

            <div class="absolute" id="onboarding-noscroll"><div class="absolute" id="onboarding-highlight"></div></div>

            <div id="onboarding" ref="bubble" class="absolute flex flex-col justify-between items-center">
                <div @click="finish()" class="absolute top-0 self-end mt-2 transform scale-75">
                    <close-button/>
                </div>
                <div class="flex flex-col mt-8 justify-center items-center h-7/10">
                    <h1 class="text-xl font-medium mb-4">{{currentStep?.title}}</h1>
                    <p  class="onboarding-content overflow-auto px-4 h-6/10">{{currentStep?.content_falc}}</p>
                </div>



                <div class="flex flex-row w-full justify-center gap-4 h-8 mb-8">
                    <action-button
                            v-if="currentStepIdx > 0"
                            libelle="Précedent"
                            class="text-2sm"
                            borderColor="border-indigo-400"
                            textColor="text-indigo-600"
                            bgColor="bg-indigo-300"
                            bgColorSquare="bg-indigo-300"
                            iconColor="text-indigo-600"
                            :uppercase="false"
                            :right="false"
                            :responsive="false"
                            @clickAction="previous()"
                    />
                    <action-button
                            v-else
                            libelle="Ignorer"
                            class="text-2sm"
                            borderColor="border-indigo-400"
                            textColor="text-indigo-600"
                            bgColor="bg-indigo-300"
                            bgColorSquare="bg-indigo-300"
                            iconColor="text-indigo-600"
                            :uppercase="false"
                            :right="false"
                            :responsive="false"
                            @clickAction="finish()"
                    />



                    <action-button
                            :libelle="currentStepIdx === filteredSteps.length -1 ? 'Fermer' : 'Suivant'"
                            class="text-2sm w-22"
                            borderColor="border-transparent"
                            textColor="text-white"
                            bgColor="bg-indigo-600"
                            bgColorSquare="bg-transparent"
                            iconColor="text-white"
                            :uppercase="false"
                            :icon="currentStepIdx !== filteredSteps.length -1 ? 'arrow-right_1' : null"
                            :right="true"
                            :responsive="false"
                            @clickAction="next()"
                    />
                </div>
                <div v-if="currentStepIdx === filteredSteps.length -1 " class="absolute transform scale-75" :style="`left: 0; top: ${this.height - 35}px;`">
                    <checkbox-indigo
                            libelle="Ne plus afficher"
                            :value="stopShowing" @input="(newValue) => {stopShowing = newValue}"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ActionButton from "../ActionButton.vue";
import onBoardingSteps from "../../constants/onboarding";
import CloseButton from "../CloseButton.vue";
import CheckboxIndigo from "../Inputs/CheckboxIndigo.vue";
import Icon from "../Icon.vue";
import axios from "axios";
import {mapGetters} from "vuex";
import HelpBubble from "./HelpBubble.vue";
export default {
  name: "Onboarding",
  components: {HelpBubble, Icon, CheckboxIndigo, CloseButton, ActionButton},

  /**
   * A step in the onboarding
   * @typedef {Object} step
   * @property {string} element The id of the target element
   * @property {string} title
   * @property {string} content
   * @property {string|null} permission The string corresponding to the permission related to the step's element or functionality
   */

  /** The onboarding for a specific page
   * @typedef {Object} onboardingPage
   * @property {string} name The name of the onboarding's page
   * @property {string|RegExp} url The string or Regexp to be matched against the current url
   * @property {step[]} steps
   */


  data() {
    return {
      enabled: false,
      showEnablePopup: false,
      pagesEnabled: {},
      shown: false,
      currentStepIdx: 0,
      onboarding: {},
      height: 240,
      width: 400,
      highlightOffset: 10,
      widthOffset: 410,
      heightOffset: 250,
      stopShowing: false,
    }
  },

  mounted() {
    this.getUserOnboarding().then(() => {
      this.tryStart()
    })
  },

  methods: {

    /**
     * Fetches the current user's onboarding and updates in-component data with it
     * @returns {Promise<void>}
     */
    async getUserOnboarding() {
      let userOnboarding = (await axios.get(`/api/onboarding/${this.user.id}`)).data
      this.enabled = userOnboarding.enabled ?? false;
      this.pagesEnabled = userOnboarding.pages_enabled ?? {};
    },

    /**
     * Finds the onboarding matching the current url from the config file, and returns it.
     * @returns {onboardingPage}
     */
    getOnboarding() {
      return onBoardingSteps.pages.filter((page) => {
        if (page.url instanceof RegExp) {
          return page.url.test(this.path)
        }
        return page.url === this.path;
      })[0];
    },

    close() {

    },

    /**
     * Fetches the latest data for the user's onboarding, then displays the "Enable" popup
     */
    askToEnable() {
      this.getUserOnboarding().then(() => {
        this.showEnablePopup = true;
      })
    },

    /**
     * Hides the "Enable" popup, then sends the user's onboarding to the server
     */
    enable() {
      this.showEnablePopup = false;
      this.enabled = true;
      axios.post(`/api/onboarding/${this.user.id}`, {
        enabled: true,
        pages_enabled: Object.fromEntries(onBoardingSteps.pages.map(page => [page.name, true])),
      }).then((response) => {
        this.enabled = response.data.enabled ?? false;
        this.pagesEnabled = response.data.pages_enabled ?? {};
        this.start()
      })
    },

    /**
     * Will try to start the onboarding on the current page if possible
     * @returns {Promise<void>}
     */
    async tryStart() {
      if (!this.hasSteps || !this.enabled) {return}
      let name = this.getOnboarding().name;
      let inStorage = !!sessionStorage.getItem(this.formatForStorage(name));
      let enabled;


      if (!inStorage) {
        await this.getUserOnboarding();
        enabled = `${name}` in this.pagesEnabled ? this.pagesEnabled[name] : true;
      } else {
        enabled = sessionStorage.getItem(this.formatForStorage(name)) === "enabled";
      }

      if (!enabled) {return}
      this.start();
    },

    /**
     * Starts the onboarding on the current page
     */
    start() {


      this.currentStepIdx = 0;
      this.onboarding = this.getOnboarding();

      if (this.onboarding.name === "neopass_form_infos_generales") {
        //Wait for a couple of seconds
        setTimeout(() => {
          this.shown = true;
          this.updatePosition('next');
        }, 2500);
        return;
      }

      this.shown = true;
      this.updatePosition('next');
    },

    /**
     * Alias for start(), to be used when bypassing tryStart()
     */
    forceStart() {
      if (!this.enabled) {
        this.askToEnable();
        return;
      }
      this.start()
    },

    /**
     * Will try to move to the previous step if possible
     */
    previous() {
      if (this.currentStepIdx === 0) {
        return;
      }
      this.currentStepIdx -= 1;
      this.updatePosition('previous');
    },

    /**
     * Will try to move to the next step if possible, else will finish
     */
    next() {
      if (this.currentStep.element === "tour_shared_library" || this.currentStep.element === "tour_personal_library") {
          this.getParentElement().click();

          //Wait for the click to be processed, then continue
          setTimeout(() => {
            if (this.currentStepIdx === this.filteredSteps.length - 1) {
              this.finish();
              return;
            }
            this.currentStepIdx += 1;
            this.updatePosition('next');
          }, 2500);
          return;
      }

      if (this.currentStepIdx === this.filteredSteps.length - 1) {
        this.finish();
        return;
      }
      this.currentStepIdx += 1;
      this.updatePosition('next');
    },

    /**
     * Will hide the onboarding and disable it for the current page for the tab's lifetime
     * If the user checked the "Do not show" checkbox, will call disable()
     */
    finish() {
      this.shown = false;
      this.currentStepIdx = 0;
      sessionStorage.setItem(this.formatForStorage(this.onboarding.name), "disabled")
      if (this.stopShowing) {
        this.disable();
      }
      this.stopShowing = false;
    },

    /**
     * Disables the current page, and sends the updated data to the server
     */
    disable() {
      this.pagesEnabled[this.onboarding.name] = false;
      axios.put(`/api/onboarding/${this.user.id}`, {
        enabled: true,
        pages_enabled: this.pagesEnabled
      });
    },

    /**
     * Formats an onboardingPage's name for use in local storage.
     * "onboarding-{userId}-{name}"
     * @param name
     * @returns {string}
     */
    formatForStorage(name) {
      return `onboarding-${this.user.id}-${name}`;
    },

    /**
     * Calls the update() method every 33ms for 2s
     * @param direction The direction to be pass through to the "update()" function
     * @returns {Promise<void>}
     */
    async updatePosition(direction) {
      let lastTopPos = 0;
      let updateCounter = 0;
      let i = setInterval(() => {
        const topPos = this.update(direction);
        const diff = Math.abs(topPos - lastTopPos);
        // Stop the interval early when the bubble is near its final position
        if (diff < 5 && updateCounter > 10) {
          clearInterval(i);
          this.update(direction);
        } else {
          lastTopPos = topPos;
        }

        updateCounter++;
      }, 33)
      await new Promise(r => setTimeout(r, 1500));
      clearInterval(i);

      // Final call to update() to ensure the bubble is in the right position
      this.update(direction);
    },

    getBackgroundOverlay() {
      let backgroundNodeList = document.querySelectorAll('#onboarding-highlight');
      let backgrounds = Array.from(backgroundNodeList);
      return backgrounds.filter((el) => el.offsetParent !== null)[0];
    },

    getParentElement() {
      let parentsNodeList = document.querySelectorAll(`#${this.element}`);
      let parents = Array.from(parentsNodeList);
      return parents.filter((el) => el.offsetParent !== null)[0];
    },

    /**
     * Updates the bubble position relative to the targeted element.
     * Will try to position it in this order: above -> left -> right -> under
     * @param direction Whether the update was called from "previous()" or "next()". Used when determining what to do when the current step's parent wasn't found.
     *
     */
    update(direction) {
      let self = document.querySelector('#onboarding') ?? this.$refs.bubble;

      let bg = this.getBackgroundOverlay();
      let parent = this.getParentElement();

      if (!parent) {
        switch (direction) {
          case 'next':
            this.next();
            return;
          case 'previous':
            this.previous();
            return;
          default:
            this.next();
            return;
        }
      }

      parent.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });

      let parentBCR = parent.getBoundingClientRect();

      let
        canPlaceAbove = this.canPlaceAbove(parentBCR),
        canPlaceUnder = this.canPlaceUnder(parentBCR),
        canPlaceRight = this.canPlaceRight(parentBCR),
        canPlaceLeft = this.canPlaceLeft(parentBCR),
        canAlignVertically = this.canAlignMiddleVertically(parentBCR),
        canAlignHorizontally = this.canAlignMiddleHorizontally(parentBCR);

      self.style.left = null;
      self.style.top = null;

      if (canPlaceAbove && canAlignVertically) {
        this.placeAbove(self, parentBCR);
        this.alignMiddleVertically(self, parentBCR);
      } else if (canPlaceLeft && canAlignHorizontally) {
        this.placeLeft(self, parentBCR);
        this.alignMiddleHorizontally(self, parentBCR);
      } else if (canPlaceRight && canAlignHorizontally) {
        this.placeRight(self, parentBCR);
        this.alignMiddleHorizontally(self, parentBCR);
      } else if (canPlaceUnder && canAlignVertically) {
        this.placeUnder(self, parentBCR);
        this.alignMiddleVertically(self, parentBCR);
      } else if (canPlaceUnder && !canAlignHorizontally && !canAlignVertically) {
        this.placeUnder(self, parentBCR);

        let diff = this.width - parentBCR.width;
        self.style.left = `${parentBCR.left - diff + this.highlightOffset}px`
      }

      bg.style.top = `${parentBCR.top - this.highlightOffset}px`;
      bg.style.left = `${parentBCR.left - this.highlightOffset}px`;
      bg.style.width = `${parentBCR.width + 2*this.highlightOffset}px`;
      bg.style.height = `${parentBCR.height + 2*this.highlightOffset}px`;

      return Math.floor(parentBCR.top);
    },

    canPlaceRight(parentBCR) {
      return (window.innerWidth - parentBCR.right) > this.widthOffset;
    },

    placeRight(self, parentBCR) {
      self.style.left = `${parentBCR.right + 2 * this.highlightOffset}px`;
      self.classList.remove("bubble-pointer-top", "bubble-pointer-bottom", "bubble-pointer-right", "bubble-pointer-left")
      self.classList.add("bubble-pointer-left")
    },

    canPlaceLeft(parentBCR) {
      return parentBCR.left > this.widthOffset;
    },

    placeLeft(self, parentBCR) {
      self.style.left = `${parentBCR.left - this.width - (2 * this.highlightOffset)}px`
      self.classList.remove("bubble-pointer-top", "bubble-pointer-bottom", "bubble-pointer-right", "bubble-pointer-left")
      self.classList.add("bubble-pointer-right")
    },

    canPlaceAbove(parentBCR) {
      return parentBCR.top > this.heightOffset;
    },

    placeAbove(self, parentBCR) {
      self.style.top = `${parentBCR.top - this.height - (2 * this.highlightOffset)}px`;
      self.classList.remove("bubble-pointer-top", "bubble-pointer-bottom", "bubble-pointer-right", "bubble-pointer-left")
      self.classList.add("bubble-pointer-bottom")
    },

    canPlaceUnder(parentBCR) {
      return (window.innerHeight - parentBCR.bottom) > this.heightOffset;
    },

    placeUnder(self, parentBCR) {
      self.style.top = `${parentBCR.bottom + 2 * this.highlightOffset}px`;
      self.classList.remove("bubble-pointer-top", "bubble-pointer-bottom", "bubble-pointer-right", "bubble-pointer-left")
      self.classList.add("bubble-pointer-top")
    },

    canAlignMiddleHorizontally(parentBCR) {
      let halfParentHeight = parseInt(parentBCR.height / 2);
      let top = parentBCR.top;
      let bottom = window.innerHeight - parentBCR.bottom;
      let smallest = Math.min(top, bottom)
      let middle = smallest + halfParentHeight;
      let halfSelfHeight = parseInt(this.height / 2);
      return middle > halfSelfHeight;
    },

    alignMiddleHorizontally(self, parentBCR){
      let halfParentHeight = parseInt(parentBCR.height / 2);
      let top = parentBCR.top;
      let middle = top + halfParentHeight;
      let halfSelfHeight = parseInt(this.height / 2);
      self.style.top = `${middle - halfSelfHeight - this.highlightOffset}px`;
    },

    canAlignMiddleVertically(parentBCR) {
      let halfParentWidth = parseInt(parentBCR.width / 2);
      let left = parentBCR.left;
      let right = window.innerWidth - parentBCR.right;
      let smallest = Math.min(left, right)
      let middle = smallest + halfParentWidth;
      let halfSelfWidth = parseInt(this.width / 2);
      return middle > halfSelfWidth;
    },

    alignMiddleVertically(self, parentBCR){
      let halfParentWidth = parseInt(parentBCR.width / 2);
      let left = parseInt(parentBCR.left);
      let middle = left + halfParentWidth;
      let halfSelfWidth = this.width / 2;
      self.style.left = `${middle - halfSelfWidth + this.highlightOffset}px`;
    },
  },

  computed: {
    ...mapGetters({
      'user': "auth/user"
    }),

    steps() {
      return this.onboarding.steps ?? [];
    },

    filteredSteps() {
      return this.steps.filter((step) => {
        if (step.hasOwnProperty('permission') && step.permission !== null) {
          return this.$can(step.permission)
        }else return true
      })
    },

    currentStep() {
      return this.filteredSteps[this.currentStepIdx] ?? {};
    },

    element() {
      return this.currentStep.element ?? "";
    },

    hasSteps() {
      return onBoardingSteps.pages.some((page) => {
        if (page.url instanceof RegExp) {
          return page.url.test(this.path)
        }
        return page.url === this.path;
      });
    },

    path() {
      return this.$route.path;
    }
  },

  watch:{
    path: function () {
      this.tryStart()
    }
  }
};
</script>

<style scoped>
#onboarding {
  height: 240px; /*same as component*/
  width: 400px; /*same as component*/
  background-color: #FFFFFF;
  border: 1px solid #FF1C80;
  border-radius: 20px;
  z-index: 500;
}

#onboarding::after,
#onboarding::before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  overflow: hidden;
}

#onboarding::after {
  z-index: 2;
}

#onboarding::before {
  z-index: 1;
}

.bubble-pointer-bottom::before,
.bubble-pointer-bottom::after,
.bubble-pointer-top::before,
.bubble-pointer-top::after,
.bubble-pointer-left::before,
.bubble-pointer-left::after,
.bubble-pointer-right::before,
.bubble-pointer-right::after {
  border: 10px solid transparent;
}

.bubble-pointer-bottom::before,
.bubble-pointer-bottom::after {
  border-top-width: 20px; /*2 * border-width*/
  border-bottom-width: 0;
}

.bubble-pointer-bottom::before {
  top: 240px; /*height*/
  border-top-color: #FF1C80;
}
.bubble-pointer-bottom::after {
  top: 238px; /*height - 2*/
  border-top-color: #FFFFFF;
}

.bubble-pointer-top::before,
.bubble-pointer-top::after {
  border-bottom-width: 20px; /*2 * border-width*/
  border-top-width: 0;
}

.bubble-pointer-top::before {
  top: -22px; /*0 - (2 * border-width) - 2*/
  border-bottom-color: #FF1C80;
}
.bubble-pointer-top::after {
  top: -20px; /*0 - (2 * border-width)*/
  border-bottom-color: #FFFFFF;
}

.bubble-pointer-left::before,
.bubble-pointer-left::after {
  border-right-width: 20px; /*2 * border-width*/
  border-left-width: 0;
  top: 120px; /*height / 2*/
}

.bubble-pointer-left::before {
  border-right-color: #FF1C80;
  left: -22px; /*0 - (2 * border-width) - 2*/
}
.bubble-pointer-left::after {
  border-right-color: #FFFFFF;
  left: -20px; /*0 - (2 * border-width)*/
}

.bubble-pointer-right::before,
.bubble-pointer-right::after {
  border-left-width: 20px; /*2 * border-width*/
  border-right-width: 0;
  top: 120px; /*height / 2*/
}

.bubble-pointer-right::before {
  border-left-color: #FF1C80;
  left: 400px; /*width*/
}
.bubble-pointer-right::after {
  border-left-color: #FFFFFF;
  left: 398px; /*width - 2*/
}

#onboarding-highlight {
  pointer-events: none;
  position: absolute;
  border-color: #FF1C80;
  border-width: 1px;
  box-shadow: 0 0 0 999999px rgba(57, 23, 209, 0.80);
  border-radius: 20px;
  z-index: 497;
}

#onboarding-noscroll {
  overscroll-behavior: contain;
  cursor: default;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 496;
}

#onboarding-noscroll-2 {
  overscroll-behavior: contain;
  cursor: default;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 40;
}

.onboarding-content {
  font-size: 18.5px;
  text-align: left;
  font-family: sans-serif;
}
</style>
